<template>
  <div class="v-wrapper">
    <div class="v-message">
      <h4>Turn your device!</h4>
      <p>Please turn your device to landscape.</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ScreenTooSmall'
}
</script>

<style scoped>
  html, body {height:100%;display:block;}
  .l-app-wrap, .l-container {height:100vw;display:block;}
  .v-wrapper {
    text-align:center;
    display: none;
    align-items: center;
    width: 100vw;
    height: 100%;
    background: #272727;
    /*background-image:url(../assets/images/logo-background.png);*/
  }

  .v-message {
    width: 100vw;
    padding:0px;
    color:#fff;
  }
  .footer {display:none;}
  @media all and (orientation:portrait) {
    html, body, .l-app-wrap, .l-container {height:100%;display:block;}
    .v-wrapper {
      z-index: 1010;
      display: flex;
      position: absolute;
      width: 100vw;
      height: 100%;
    }
    h4 {margin:0;line-height:auto;}
    p {margin:0;line-height:auto;}
}
</style>



// WEBPACK FOOTER //
// src/components/ScreenTooSmall.vue